import { useMemo } from 'react';
import { useSubscriptionsAndAllowedFeaturesContext } from 'contexts/SubscriptionsAndAllowedFeaturesContext/SubscriptionsAndAllowedFeaturesContext';
import { i18n } from 'utils';
import { ServiceOfferKind } from 'types/generated/graphql';
import { getClosestSamplesBillingDate } from './getClosestSamplesBillingDate';

export const useClosestSamplesBillingDate = () => {
    const { subscriptionsDetails } =
        useSubscriptionsAndAllowedFeaturesContext();

    const closestNextSamplesBillingDate = useMemo(() => {
        const currentSubscriptions =
            subscriptionsDetails
                ?.filter((sub) => {
                    const isServiceOfferAllowingSamples =
                        sub.serviceOffer === ServiceOfferKind.Samples ||
                        sub.serviceOffer === ServiceOfferKind.Bundles ||
                        sub.serviceOffer === ServiceOfferKind.Partners;
                    const hasCurrentSubscription = !!sub.current;

                    return (
                        isServiceOfferAllowingSamples && hasCurrentSubscription
                    );
                })
                ?.map((sub) => sub.current) ?? [];

        return getClosestSamplesBillingDate(currentSubscriptions);
    }, [subscriptionsDetails]);

    const formattedDate = useMemo(() => {
        if (!closestNextSamplesBillingDate) {
            return '';
        }

        return new Intl.DateTimeFormat(i18n.locale, {
            dateStyle: 'long',
        }).format(closestNextSamplesBillingDate);
    }, [closestNextSamplesBillingDate]);

    return { formattedDate };
};
